import { Select } from "antd";
import { Converse } from "./Converse";
import {
  ModusProvider,
  useModus,
  MicRecorderProvider
} from "@vojomo-core/shared";

export const Chat = ({
  agent,
  agentSelector,
  showTranscriptIcon,
  showNewConversationButton
}: {
  agent: string;
  agentSelector?: boolean;
  showTranscriptIcon?: boolean;
  showNewConversationButton?: boolean;
}) => {
  return (
    <ModusProvider agentName={agent}>
      <MicRecorderProvider>
        <ChatInternal
          agentSelector={agentSelector}
          showTranscriptIcon={showTranscriptIcon}
          showNewConversationButton={showNewConversationButton}
        />
      </MicRecorderProvider>
    </ModusProvider>
  );
};

export const ChatInternal = ({
  agentSelector,
  showTranscriptIcon,
  showNewConversationButton
}: {
  agentSelector?: boolean;
  showTranscriptIcon?: boolean;
  showNewConversationButton?: boolean;
}) => {
  const {
    agentsList,
    sendMessage,

    activeAgent,
    setActiveAgent
  } = useModus();

  const onProcess = async (transcript: string, _: string) => {
    await sendMessage(transcript);
  };

  return (
    <div>
      <div>
        <div className="flex flex-row items-center mt-0 justify-between">
          <div className="flex flex-row items-center">
            {agentSelector && (
              <>
                <p className="text-center mr-4 font-bold">Agent</p>
                <Select
                  showSearch
                  style={{ width: 200 }}
                  options={agentsList}
                  onChange={(value) => setActiveAgent(value)}
                  defaultValue={activeAgent || "Modus"}
                  placeholder="Select an agent"
                />
              </>
            )}
          </div>
        </div>

        <div className="flex flex-row justify-between">
          <div
            style={{
              flexShrink: 0,
              flexGrow: 0,
              minWidth: "80vw",
              maxWidth: "80vw",
              width: "80vw",
              marginLeft: "0px"
            }}
          >
            <Converse
              size={275}
              onProcess={onProcess}
              showTranscriptIcon={showTranscriptIcon}
              showNewConversationButton={showNewConversationButton}
              // textAlignOverride="left"
              // justifyContentOverride="left"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
